import { useState } from 'react';
import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              热播推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精选热门影视内容，每日更新，为你推荐最值得看的电影和剧集
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {cards.map((item, idx) => (
              <CardItem key={idx} item={item} index={idx} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CardItem({
  item,
  index,
}: {
  item: (typeof cards)[number];
  index: number;
}) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group relative bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
      <div className="relative aspect-[2/3] overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-background-200">
            <i className="ri-movie-2-line text-4xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md">
          {item.rating}
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      <div className="p-3 md:p-4">
        <span className="inline-block text-[10px] md:text-xs text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full mb-2">
          {item.category}
        </span>
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-1 line-clamp-1">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.desc}</p>
      </div>
    </div>
  );
}